<template>
    <basic-container>
    <div class="list_wrapper">
        <div class="header_wrapper">
            <div class="header_left">
                已终止的项目
            </div>
        </div>
        <el-row class="search_wrapper" type="flex" justify="space-between">
            <el-col>
                <el-form :inline="true" :model="searchForm" ref="formRef">
                    <el-form-item>
                        <el-input v-model="searchForm.number" placeholder="项目编号" clearable />
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="searchForm.projectName" placeholder="项目名称" clearable />
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchForm.projectType" placeholder="项目类型">
                            <el-option v-for="(item) in dictionaryData.zsProjectTypeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item >
                        <el-date-picker
                            @change="queryTableData"
                            v-model="searchForm.timePic"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                   
                    <el-form-item>
                        <el-button type="primary" @click="searchBtn" >
                            查询
                            <template #icon>
                                <SearchOutlined />
                            </template>
                        </el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="resetBtn" > 重置 </el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <div class="table_list">
            <el-table v-loading="tableLoading" :headerCellStyle="{ background: '#ECF5FF', color: '#333' }" :data="tableData"
                style="width: 100%;" border>
                
                <el-table-column label="项目编号" prop="number" width="150" align="center">
                </el-table-column>
                <el-table-column label="项目名称" prop="projectName" align="center"></el-table-column>
                <el-table-column label="项目类型" prop="projectType" width="100" align="center">
                    <template slot-scope="scope">
                        {{ dictionaryLabel(scope.row.projectType,dictionaryData.zsProjectTypeList) }}
                    </template>  
                </el-table-column>
                <el-table-column label="项目状态" prop="projectStatus" width="100" align="center">
                    <template slot-scope="scope">
                        {{ dictionaryLabel(scope.row.projectStatus,dictionaryData.zsProjectStatusList) }}
                    </template> 
                </el-table-column>
                <el-table-column label="申报时间"  align="center">
                    <template slot-scope="scope">
                        {{ scope.row.applyTime?moment(scope.row.applyTime).format("YYYY-MM-DD HH:mm"):'/' }}
                    </template>  
                </el-table-column>
                <el-table-column label="申报人"  prop="createUserName" align="center">
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="70" align="center">
                    <template slot-scope="scope">
                        <div class="menu_action">
                            <el-button @click="handleDetail(scope.row)"  type="success" plain size="mini">详情</el-button>
                        </div>

                    </template>
                </el-table-column>
            </el-table>

            <div class="bottom_container">
                <el-pagination background layout="prev, pager, next"
                     @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="page.currentPage" :total="page.total">
                </el-pagination>
            </div>
        </div>
    </div>
</basic-container>
</template>
<script >
import tableList from '@/mixins/tableList'
import * as api from '@/api/zs/zs'
import util from "@/mixins/util";
import moment from "moment"
let searchFormData = {
    number: undefined,
    projectName: undefined,
    projectType: undefined,
    timePic:[]
};

export default {

    name: 'projectTerminated',
    mixins: [tableList,util],
    data() {
        

        return {
            searchForm: Object.assign({}, searchFormData),
            tableData: [{}],
            tableLoading: false,
            formLoading: false,
            dialogFormVisible: false,
            dictionaryData:{}

        }
    },
    async mounted() {
        let dataList = [
            { code: "zs_project_type", name: "zsProjectTypeList" },
            { code: "zs_project_status", name: "zsProjectStatusList" },
        ];
        let dictionaryData = await this.dictionaryAllMap(dataList);
        this.dictionaryData=dictionaryData

        this.queryTableData()
    },
    methods: {
        moment,

        //列表数据
        async queryTableData() {
            this.tableLoading = true
            let params = {
                current: this.page.currentPage,
                size: this.page.pageSize,
                ...this.searchForm,
                applyTimeStart: this.searchForm.timePic.length>0
                ? moment(this.searchForm.timePic[0]).format("YYYY-MM-DD")
                : undefined,
                applyTimeEnd: this.searchForm.timePic.length>0
                ? moment(this.searchForm.timePic[1]).format("YYYY-MM-DD")
                : undefined,
                projectStatus:9

            };
            delete params.timePic
            let res = await api.getProjectQueryList(params).catch(() => {
                this.tableLoading = false
            });
            if (res.data.code == 200) {
                this.tableLoading = false
                this.tableData = res.data.data.records
                this.page.total = res.data.data.total
                this.page.pageSize = res.data.data.size
            }

        },
        
        
        
        //查看
        handleDetail(row) {
            this.$router.push({
                path: `/zsProject/projectDetail/${row.id}`
            })
        },
        
        // 重置
        resetBtn() {
            this.searchForm = Object.assign({}, searchFormData)
            this.searchBtn()
        }

    },

}


</script>

<style lang="scss" scoped>
@import "@/styles/list.scss";
</style>